import {
  ScreenActions,
  ScreenActionTypes
} from '../actions/screen.actions';

export interface ScreenState {
  xs: boolean;
  sm: boolean;
  md: boolean;
  lg: boolean;
  xl: boolean;
  ltsm: boolean;
  ltmd: boolean;
  ltlg: boolean;
  ltxl: boolean;
  gtxs: boolean;
  gtsm: boolean;
  gtmd: boolean;
  gtlg: boolean;
}

export const screenInitialState: ScreenState = {
  xs:   false,
  sm:   false,
  md:   false,
  lg:   false,
  xl:   false,
  ltsm: false,
  ltmd: false,
  ltlg: false,
  ltxl: false,
  gtxs: false,
  gtsm: false,
  gtmd: false,
  gtlg: false
};

export function screenReducer(
  state = screenInitialState,
  action: ScreenActions,
): ScreenState {
  switch (action.type) {

    case ScreenActionTypes.MDLayout:
      return { ...state, xs: false, sm: false, md: true, lg: false, xl: false };

    case ScreenActionTypes.SMLayout:
      return { ...state, xs: false, sm: true, md: false, lg: false, xl: false };

    case ScreenActionTypes.XSLayout:
      return { ...state, xs: true, sm: false, md: false, lg: false, xl: false };

    case ScreenActionTypes.LGLayout:
      return { ...state, xs: false, sm: false, md: false, lg: true, xl: false };

    case ScreenActionTypes.XLLayout:
      return { ...state, xs: false, sm: false, md: false, lg: false, xl: true };

    case ScreenActionTypes.GTLGLayout:
      return { ...state, gtlg: true, gtmd: true, gtsm: true, gtxs: true };

    case ScreenActionTypes.GTMDLayout:
      return { ...state, gtlg: false, gtmd: true, gtsm: true, gtxs: true };

    case ScreenActionTypes.GTSMLayout:
      return { ...state, gtlg: false, gtmd: false, gtsm: true, gtxs: true };

    case ScreenActionTypes.GTXSLayout:
      return { ...state, gtlg: false, gtmd: false, gtsm: false, gtxs: true };

    case ScreenActionTypes.LTLGLayout:
      return { ...state, ltxl: true, ltlg: true, ltmd: false, ltsm: false };

    case ScreenActionTypes.LTMDLayout:
      return { ...state, ltxl: true, ltlg: true, ltmd: true, ltsm: false };

    case ScreenActionTypes.LTSMLayout:
      return { ...state, ltxl: true, ltlg: true, ltmd: true, ltsm: true };

    case ScreenActionTypes.LTXLLayout:
      return { ...state, ltxl: true, ltlg: false, ltmd: false, ltsm: false };

    default:
      return state;
  }
}
